<template>
    <BetBuilderLegs
        v-if="useLegs"
        :legs="computedLegs"
        :isExpandable="isExpandable"
        :isExpanded="isExpanded"
        :limit="limit"
    />
    <div
        v-else
        class="superbets__details"
        :class="{
            'superbets__details--contracted' : overflowingCount > 0,
            'superbets__details--expanded' : isExpanded,
        }"
    >
        <div
            v-for="(part, index) in visibleParts"
            :key="part"
            class="superbets__segment superbets__segment--main"
        >
            <span class="superbets__segment-text">
                <slot
                    name="leg"
                    :label="part"
                    :index="index"
                >
                    {{ part }}
                </slot>
            </span>
        </div>
        <template v-if="isExpandable && overflowingCount > 0">
            <span class="superbets__segment superbets__segment--rest">
                + {{ overflowingCount }} {{ $tc('betBuilder.summary.moreSelections', overflowingCount) }}
            </span>
        </template>
    </div>
</template>

<script>
    import {
        getSuperBetParts,
        validateBetBuilderLegs,
    } from '@modules/eventGrid/components/markets/helpers';
    import { OddStatus } from '@superbet-group/web.types';
    import { mapGetters } from 'vuex';

    export default {
        name: 'SuperBetsDetails',
        props: {
            name: {
                type: String,
                required: true,
            },
            // TODO: remove once all usage is removed
            eventComponents: {
                type: Array,
                default: null,
            },
            legs: {
                type: Array,
                default: null,
            },
            specifiers: {
                type: Object,
                default: () => ({}),
            },
            isExpandable: {
                type: Boolean,
                required: false,
                default: false,
            },
            isExpanded: {
                type: Boolean,
                required: false,
                default: false,
            },
            limit: {
                type: Number,
                required: false,
                default: 3,
            },
        },
        computed: {
            ...mapGetters('ui/sportOffer/experiments', [
                'isPerLegSettlementStatusEnabled',
            ]),
            computedLegs() {
                return this.legs ?? this.eventComponents?.map(({
                    market,
                    oddComponent,
                }) => ({
                    name: `${market.name}: ${oddComponent.name}`,
                    status: oddComponent.oddStatus ?? OddStatus.Unspecified,
                }));
            },
            useLegs() {
                return (this.isPerLegSettlementStatusEnabled && validateBetBuilderLegs(this.computedLegs));
            },
            parts() {
                return getSuperBetParts(
                    this.name,
                    this.specifiers,
                );
            },
            overflowingCount() {
                const limit = (this.isExpandable && this.parts.length > this.limit) ? this.limit - 1 : this.parts.length;
                return this.isExpanded ? 0 : this.parts.length - limit;
            },
            visibleParts() {
                const limit = (this.isExpandable && !this.isExpanded && this.parts.length > this.limit) ? this.limit - 1 : this.parts.length;
                return this.parts.slice(0, limit);
            },
        },
        components: {
            BetBuilderLegs: () => import('./BetBuilderLegs.vue'),
        },
    };
</script>

<style lang="scss" scoped>
@import '~@superbet-group/web.lib.global-styles/type';

.superbets__segment {
    @include font-11-regular;
    color: var(--system-text-on-elevation-tertiary);
}
</style>
